import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { IJBPPlanning } from 'partner360/entities/planning'
import { sumActivities } from 'partner360/features/mdfActivities/helpers/sumActivities'
import {
  getMdfContraMetrics,
  IMdfContraMetrics,
} from 'partner360/features/mdfActivities/lib/getMdfContraMetrics'
import { IMdfActivity } from 'partner360/features/mdfActivities/model/types'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

export interface IKeyInitiativeMdfScope {
  partnerId: string
  fYear: number
  programType: ProgramTypes
  actualsType: ActualsValueTypes
  period: readonly string[]
  businessUnit: string
  focusArea: string
}

export interface IKeyInitiativeMdfMetrics extends IMdfContraMetrics {
  plannedUsd: number
  paidUsd: number
}

export const getKeyInitiativeMdfMetrics = (
  activities: IMdfActivity[],
  rows: IJBPPlanning[],
  { period, businessUnit, focusArea, ...scope }: IKeyInitiativeMdfScope
): IKeyInitiativeMdfMetrics => {
  const { requested, paid } = sumActivities(activities, true)
  const focusIds = focusArea
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean)
  const unit = businessUnit.trim()
  // FocusArea stores product-tree IDs. With no focus, use BU; with neither, the offering.
  const businessFocus = focusIds.length
    ? focusIds
    : unit && unit !== scope.programType
      ? [unit]
      : []
  const contra = getMdfContraMetrics(activities, period.length ? rows : [], {
    ...scope,
    timeframes: period,
    businessFocus,
  })

  // "Planned" is the linked MDF's Requested amount, not KI.HPInvestmentSum.
  // Always compare USD with USD, even if the editor/table displays local currency.
  return { ...contra, plannedUsd: requested, paidUsd: paid }
}
